import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import UserLayout from './layouts/UserLayout';
import AdminLayout from './layouts/AdminLayout';
import FranchiseLayout from './layouts/FranchiseLayout';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import HomePage from './pages/user/HomePage';
import RentalPage from './pages/user/RentalPage';
import RidePage from './pages/user/RidePage';
import RideOrderPage from './pages/user/RideOrderPage';
import ProfilePage from './pages/user/ProfilePage';
import MetaversePage from './pages/user/MetaversePage';
import AdminDashboard from './pages/admin/AdminDashboard';
import OrderManagement from './pages/admin/OrderManagement';
import UserManagement from './pages/admin/UserManagement';
import FranchiseManagement from './pages/admin/FranchiseManagement';
import FranchiseDashboard from './pages/franchise/FranchiseDashboard';
import FranchiseVehicleManagement from './pages/franchise/VehicleManagement';
import FranchiseDriverManagement from './pages/franchise/DriverManagement';
import FranchiseOrderManagement from './pages/franchise/OrderManagement';
import FranchiseUserManagement from './pages/franchise/UserManagement';
import PermissionGuard from './components/PermissionGuard';
import './App.css';

const { Content } = Layout;

const App: React.FC = () => {
  return (
    <Layout className="app-layout">
      <Content>
        <Routes>
          {/* Auth Pages */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* User Routes */}
          <Route path="/" element={<UserLayout />}>
            <Route index element={<HomePage />} />
            <Route path="rental" element={<RentalPage />} />
            <Route path="ride" element={<RidePage />} />
            <Route path="ride-order" element={<RideOrderPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="metaverse" element={<MetaversePage />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin" element={
            <PermissionGuard userType="admin">
              <AdminLayout />
            </PermissionGuard>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="orders" element={<OrderManagement />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="franchises" element={<FranchiseManagement />} />
          </Route>

          {/* Franchise Routes */}
          <Route path="/franchise" element={
            <PermissionGuard userType="franchise">
              <FranchiseLayout />
            </PermissionGuard>
          }>
            <Route index element={<FranchiseDashboard />} />
            <Route path="vehicles" element={<FranchiseVehicleManagement />} />
            <Route path="drivers" element={<FranchiseDriverManagement />} />
            <Route path="orders" element={<FranchiseOrderManagement />} />
            <Route path="users" element={<FranchiseUserManagement />} />
          </Route>

          {/* Default Redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Content>
    </Layout>
  );
};

export default App;